const Seo = {
  init() {
    Seo.events();
  },
  events() {
    $('.seo__button').on('click', (e) => {
      const btn = $(e.currentTarget);
      $('.seo__text--large').slideDown();

      btn.toggleClass('opened');

      if (btn.hasClass('opened')) {
        btn.find('.text').text(btn.data('less'));
      } else {
        btn.find('.text').text(btn.data('more'));
        $('.seo__text--large').slideUp();
      }
    });
  },
};

export default Seo;
